// extracted by mini-css-extract-plugin
export default {"divCl":"SearchSection_divCl__c7cSk","childrenElem":"SearchSection_childrenElem__2SegF","inpCl":"SearchSection_inpCl__TFHA0"};